import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column pl-2 pr-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 mb-2 flex align-items-center flex-column md:justify-content-start md:flex-row" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "" }, "VYHĽADÁVANIE A REZERVÁCIA KUSOV")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReservedItems = _resolveComponent("ReservedItems")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ReservedItems, {
      orderId: String(-1),
      reserved: true,
      search: true
    }, null, 8, ["orderId"]),
    _createVNode(_component_ConfirmDialog)
  ]))
}